import { captureException } from "@sentry/nextjs";
import { log } from "~features/seated-reservation/helpers/stateLogger";
import { getState, SeatType } from "../index";
import { setSeats } from "./setSeats";

interface ActionProps {
  seatId: string;
  ticketType: SeatType["ticketType"];
}

export const updateSeatType = (payload: ActionProps) => {
  log("updateSeatType", payload);

  const state = getState();

  const { seatId, ticketType } = payload;

  if (!ticketType || !ticketType?.value || !ticketType?.label) {
    captureException(
      new Error(
        "setSeatType: Attempting to set seat type without a ticket type."
      ),
      {
        tags: {
          action: "setSeatType",
        },
        extra: {
          state: state.seats,
        },
      }
    );
  }

  const updatedSeats = state.seats.map((seat) => {
    if (seat.id === seatId || seat.customId === seatId) {
      return {
        ...seat,
        ticketType,
      };
    }

    return seat;
  });

  setSeats({ seats: updatedSeats });
};
